import { event } from '@zillow/universal-analytics';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { getCookieValue } from '../../utils/cookies/getCookieValue.js';
import SimonScript from '../SimonScript/SimonScript.js';
import { onError } from './SimonForm.utils.js';

var SimonForm = function SimonForm(_ref) {
  var persona = _ref.persona,
    storageEnvironment = _ref.storageEnvironment,
    subscriptionListName = _ref.subscriptionListName,
    treatmentName = _ref.treatmentName,
    children = _ref.children,
    id = _ref.id;
  var methods = useForm({
    mode: 'onTouched'
  });
  var onSubmit = function onSubmit(data, e) {
    var properties = {
      eventName: 'CMS Simon Form',
      persona: persona,
      subscriptionListName: subscriptionListName,
      treatmentName: treatmentName
    };

    // Add all form data to properties except email, which is added to the root.
    Object.keys(data).forEach(function (key) {
      if (key !== 'email') {
        properties[key] = data[key];
      }
    });
    var userId = getCookieValue('zjs_user_id') !== null ? getCookieValue('zjs_user_id').replace(/[^A-Za-z0-9\-_]/g, '') : null;
    window.sd.identify(userId, Object.assign({}, data.email && {
      email: data.email
    }, {
      properties: properties
    }));

    // ClickStream event tracking.(CMS-3570)
    event({
      // https://dataportal.zillowgroup.net/event-registry/2055
      envelope: {
        event_type_id: '2055',
        event_type_version_id: '1',
        event_template_id: '126',
        event_template_version_id: '1'
      },
      clickstream_trigger: {
        trigger_type_nm: 'interaction',
        trigger_location_nm: 'cms',
        trigger_source_nm: 'cms_button',
        trigger_object_nm: 'no_trigger_object'
      },
      cms_info: {
        block_id: e.target.id || '',
        block_type_cd: 'simon_data_form',
        form_submit_label: e.target.querySelector('[type="submit"]').textContent
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimonScript, {
    storageEnvironment: storageEnvironment
  }), /*#__PURE__*/React.createElement(FormProvider, methods, /*#__PURE__*/React.createElement("form", {
    onSubmit: methods.handleSubmit(onSubmit, onError),
    id: id,
    noValidate: true
  }, children)));
};
SimonForm.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  persona: PropTypes.array,
  treatmentName: PropTypes.string,
  storageEnvironment: PropTypes.string.isRequired,
  subscriptionListName: PropTypes.string
} : {};
var SimonForm$1 = SimonForm;

export { SimonForm$1 as default };
